function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { DateRangeShortcutHelper, i18n, SessionSelectors } from 'invision-core';
import LocaleKeys from '../../../locales/keys';
import { searchCouponRedemptions, searchRedemptionCodes, setCurrentGrantedCouponsPage, setGrantedCouponsGrantDateEndFilter, setGrantedCouponsGrantDateStartFilter, setGrantedCouponsNameOrCodeFilter, setGrantedCouponsRedemptionStatusFilter, setPageSizePreference } from '../../../reducers/actions/customer.coupons.actions';
import { CurrentCustomerIdSelector, CurrentCustomerSelector } from '../../../reducers/selectors/customer.selectors';
import { GrantedCouponsCurrentPageNumberSelector, GrantedCouponsGrantDateEndFilterSelector, GrantedCouponsGrantStartFilterSelector, GrantedCouponsNameOrCodeFilterSelector, GrantedCouponsRecordCountSelector, GrantedCouponsRedemptionStatusFilterSelector, GrantedCouponsTableDataSelector, IsFetchingRedemptionCodesSelector, IsFetchingCouponRedemptionsSelector, SelectedPageSizePreference } from '../../../reducers/selectors/customer.coupons.selectors';
import { LanguageHeaderSelector } from 'invision-core/src/components/session/session.selectors';
var REDEMPTION_STATUS_ALL = 1;
var REDEMPTION_STATUS_NOT_REDEEMED = 2;
var REDEMPTION_STATUS_REDEEMED = 3;
var SORT_DIRECTION_DESCENDING = 2;
var CustomerCouponsController = /*#__PURE__*/function () {
  function CustomerCouponsController($ngRedux) {
    _classCallCheck(this, CustomerCouponsController);
    this.$ngRedux = $ngRedux;
    this.CustomerLocaleKeys = LocaleKeys;
  }
  return _createClass(CustomerCouponsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var columnDefs = [{
        field: 'DateGranted',
        displayName: i18n.translate(LocaleKeys.COUPONS.DATE_GRANTED),
        width: 120,
        cellFilter: 'date:"shortDate"'
      }, {
        field: 'Status',
        displayName: i18n.translate(LocaleKeys.STATUS),
        width: 140,
        cellTemplate: require('./cellTemplates/status.html')
      }, {
        field: 'RedemptionCode',
        displayName: i18n.translate(LocaleKeys.COUPONS.REDEMPTION_CODE),
        minWidth: 150,
        cellTemplate: require('./cellTemplates/redemption.code.html')
      }, {
        field: 'Coupon',
        displayName: i18n.translate(LocaleKeys.NAME),
        minWidth: 150
      }, {
        field: 'OrderNumber',
        displayName: i18n.translate(LocaleKeys.ORDER_NUMBER),
        width: 130,
        cellTemplate: require('./cellTemplates/order.html')
      }, {
        field: 'LastRedeemed',
        displayName: i18n.translate(LocaleKeys.COUPONS.LAST_REDEEMED),
        width: 125,
        cellFilter: 'date:"shortDate"'
      }, {
        field: 'ExpirationDate',
        displayName: i18n.translate(LocaleKeys.COUPONS.EXPIRATION_DATE),
        width: 125,
        cellFilter: 'date:"shortDate"'
      }];
      this.redemptionStatusOptions = [{
        id: REDEMPTION_STATUS_ALL,
        text: i18n.translate(LocaleKeys.ALL),
        selected: true
      }, {
        id: REDEMPTION_STATUS_REDEEMED,
        text: i18n.translate(LocaleKeys.COUPONS.REDEEMED),
        selected: false
      }, {
        id: REDEMPTION_STATUS_NOT_REDEEMED,
        text: i18n.translate(LocaleKeys.COUPONS.NOT_REDEEMED),
        selected: false
      }];
      this.mapStateToTarget = function (store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentPageNumber: GrantedCouponsCurrentPageNumberSelector(store),
          grantDateEndFilter: GrantedCouponsGrantDateEndFilterSelector(store),
          grantDateStartFilter: GrantedCouponsGrantStartFilterSelector(store),
          languageHeader: LanguageHeaderSelector(store),
          nameOrCodeFilter: GrantedCouponsNameOrCodeFilterSelector(store),
          redemptionStatusFilter: GrantedCouponsRedemptionStatusFilterSelector(store),
          isFetchingCouponRedemptions: IsFetchingCouponRedemptionsSelector(store),
          isFetchingRedemptionCodes: IsFetchingRedemptionCodesSelector(store),
          recordCount: GrantedCouponsRecordCountSelector(store),
          selectedPageSizePreference: SelectedPageSizePreference(store),
          tableData: {
            columnDefs: columnDefs,
            data: GrantedCouponsTableDataSelector(store)
          },
          userPageSizePreference: SessionSelectors.PageSizePreferenceSelector(store)
        };
      };
      this.controllerActions = {
        searchCouponRedemptions: searchCouponRedemptions,
        searchRedemptionCodes: searchRedemptionCodes,
        setCurrentGrantedCouponsPage: setCurrentGrantedCouponsPage,
        setGrantedCouponsGrantDateEndFilter: setGrantedCouponsGrantDateEndFilter,
        setGrantedCouponsGrantDateStartFilter: setGrantedCouponsGrantDateStartFilter,
        setGrantedCouponsNameOrCodeFilter: setGrantedCouponsNameOrCodeFilter,
        setGrantedCouponsRedemptionStatusFilter: setGrantedCouponsRedemptionStatusFilter,
        setPageSizePreference: setPageSizePreference
      };
      this.disconnectRedux = this.$ngRedux.connect(this.mapStateToTarget, this.controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.stateOrName = 'index.customercare.customer.coupons';
      this.searchTerm = this.state.nameOrCodeFilter || undefined;
      this.optionalParams = {
        customerId: this.state.currentCustomerId
      };
      this.initDateRange().then(function () {
        if (!_this.state.selectedPageSizePreference) {
          _this.actions.setPageSizePreference(_this.state.userPageSizePreference);
        }
        _this.redemptionStatusOptions.forEach(function (status) {
          status.selected = _this.state.redemptionStatusFilter === status.id;
        });
      });
    }
  }, {
    key: "initDateRange",
    value: function initDateRange() {
      var entireHistoryDateShortcut = DateRangeShortcutHelper.getNullableOption(i18n.translate(LocaleKeys.ALL_TIME));
      this.shortcuts = [[entireHistoryDateShortcut].concat(DateRangeShortcutHelper.getRelativeShortListShortcuts())];
      return Promise.resolve(this.onDateRangeChanged(entireHistoryDateShortcut.start, entireHistoryDateShortcut.end, entireHistoryDateShortcut));
    }
  }, {
    key: "onPageSelected",
    value: function onPageSelected(page) {
      this.actions.setCurrentGrantedCouponsPage(page);
      return this.searchCouponCodesAndRedemptions();
    }
  }, {
    key: "onDateRangeChanged",
    value: function onDateRangeChanged(start, end, shortcut) {
      this.selectedShortcut = shortcut;
      this.actions.setGrantedCouponsGrantDateStartFilter(start);
      this.actions.setGrantedCouponsGrantDateEndFilter(end);
      return this.onPageSelected(1);
    }
  }, {
    key: "onSearchTermSubmitted",
    value: function onSearchTermSubmitted(searchTerm) {
      this.searchTerm = searchTerm;
      this.actions.setGrantedCouponsNameOrCodeFilter(searchTerm);
      this.onPageSelected(1);
    }
  }, {
    key: "clearSearchText",
    value: function clearSearchText() {
      this.searchTerm = null;
      this.onSearchTermSubmitted();
    }
  }, {
    key: "onRedemptionStatusOptionSelect",
    value: function onRedemptionStatusOptionSelect(status) {
      var _this2 = this;
      if (status) {
        this.actions.setGrantedCouponsRedemptionStatusFilter(status.id);
      }
      this.redemptionStatusOptions.forEach(function (status) {
        status.selected = false;
        if (_this2.state.redemptionStatusFilter === status.id) {
          status.selected = true;
        }
      });
      this.onPageSelected(1);
    }
  }, {
    key: "generateRedemptionCodeFilter",
    value: function generateRedemptionCodeFilter() {
      return {
        couponName: this.state.nameOrCodeFilter,
        grantEnd: this.state.grantDateEndFilter,
        grantStart: this.state.grantDateStartFilter,
        pageSize: this.state.selectedPageSizePreference,
        pageNumber: this.state.currentPageNumber,
        redemptionStatus: this.state.redemptionStatusFilter,
        searchString: this.state.nameOrCodeFilter,
        sortDirection: SORT_DIRECTION_DESCENDING
      };
    }
  }, {
    key: "searchCouponCodesAndRedemptions",
    value: function searchCouponCodesAndRedemptions() {
      var searchRedemptionCodesFilterData = this.generateRedemptionCodeFilter();
      var searchCouponRedemptionsFilterData = {
        couponName: this.state.nameOrCodeFilter,
        searchString: this.state.nameOrCodeFilter,
        pageSize: this.state.selectedPageSizePreference
      };
      return Promise.all([this.actions.searchCouponRedemptions(this.state.currentCustomerId, searchCouponRedemptionsFilterData, this.state.languageHeader), this.actions.searchRedemptionCodes(this.state.currentCustomerId, searchRedemptionCodesFilterData)]);
    }
  }, {
    key: "hasFiltersApplied",
    value: function hasFiltersApplied() {
      return this.state.nameOrCodeFilter || this.state.includeSearch || this.state.grantDateStartFilter || this.state.grantDateEndFilter || this.state.redemptionStatusFilter;
    }
  }, {
    key: "onPageSizeOptionSelected",
    value: function onPageSizeOptionSelected(pageSize) {
      this.actions.setPageSizePreference(pageSize);
      this.onPageSelected(1);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {},
  template: require('./customer.coupons.html'),
  controller: CustomerCouponsController,
  controllerAs: 'CustomerCouponsController'
};